'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactGoogleMaps = require('react-google-maps');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Map = function Map(_ref) {
  var zoom = _ref.zoom,
      center = _ref.center,
      options = _ref.options,
      zones = _ref.zones,
      styling = _ref.styling,
      onZone = _ref.onZone,
      onMouseOut = _ref.onMouseOut,
      onMouseOver = _ref.onMouseOver;
  return _react2.default.createElement(_reactGoogleMaps.GoogleMap, {
    defaultZoom: zoom,
    defaultCenter: center,
    options: options
  }, zones.map(function (zone) {
    return _react2.default.createElement(_reactGoogleMaps.Polygon, {
      key: zone.key,
      path: zone.path,
      options: styling(zone),
      onClick: onZone(zone),
      onMouseOver: onMouseOver(zone),
      onMouseOut: onMouseOut(zone)
    });
  }));
}; // Components


Map.propTypes = {
  zoom: _propTypes2.default.number,
  center: _propTypes2.default.object,
  options: _propTypes2.default.object,
  zones: _propTypes2.default.array,
  styling: _propTypes2.default.func,
  onZone: _propTypes2.default.func,
  onMouseOut: _propTypes2.default.func,
  onMouseOver: _propTypes2.default.func
};
exports.default = (0, _reactGoogleMaps.withGoogleMap)(Map);